import React from "react";
import styled from "styled-components";
import { getPositionSegmentEdges } from "common/util/pagination_index/pagination";
import { MAX_NUM_NAV } from "constant/dl_unit/dl_unit.constant";

type Props = {
  page: number;
  scansTotal: number;
  onNumClick: (num: number) => void;
};

export default function UnitScanNumNav({
  page,
  scansTotal,
  onNumClick,
}: Props) {
  const { borderLeft, borderRight } = getPositionSegmentEdges(
    page - 1,
    MAX_NUM_NAV,
    0,
    scansTotal - 1
  );

  const numNavs = [];
  for (let i = borderLeft; i <= borderRight; i++) {
    numNavs.push(
      <NumNav
        key={"numNav_" + i}
        active={i + 1 === page}
        onClick={() => onNumClick(i)}
      >
        {i + 1}
      </NumNav>
    );
  }

  return <>{numNavs}</>;
}

const NumNav = styled.span<{ active?: boolean }>`
  display: inline-block;
  width: 25px;
  text-align: left;
  cursor: pointer;
  font-weight: ${(props) => (props.active ? "bold" : "inherit")};
`;
